import { defineComponent as u, computed as i, openBlock as p, createBlock as y, unref as d, mergeProps as c, withCtx as r, renderSlot as o } from "vue";
import { renderMultipleSelectTag as v, renderSingleSelectTag as b, defaultRenderLabel as h } from "./ghl-ui.es354.js";
import { renderLabelAsAvatar as S } from "./ghl-ui.es355.js";
import { renderGroupLabel as w } from "./ghl-ui.es356.js";
import { renderTooltip as B } from "./ghl-ui.es357.js";
import { renderMultipleSelectedAsAvatar as T, renderSingleSelectedAsAvatar as A } from "./ghl-ui.es358.js";
import $ from "./ghl-ui.es359.js";
const L = u({
  name: "UISelect",
  inheritAttrs: !1
}), C = u({
  ...L,
  props: {
    id: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    show: {
      type: Boolean,
      default: void 0
    },
    multiple: {
      type: Boolean,
      default: void 0
    },
    filterable: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: void 0
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    remote: {
      type: Boolean,
      default: void 0
    },
    tag: {
      type: Boolean,
      default: void 0
    },
    type: {
      type: String,
      default: "default"
    },
    resetMenuOnOptionsChange: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: "large"
    },
    maxTagCount: {
      type: Number,
      default: void 0
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String
    },
    value: {
      type: [String, Array]
    },
    renderLabel: {
      type: Function,
      default: void 0
    },
    renderTag: {
      type: Function,
      default: void 0
    },
    showTooltip: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["search", "update:value", "scroll", "update:show"],
  setup(e) {
    const n = e, s = (t, a) => {
      switch (t.type ?? n.type) {
        case "avatar":
        default:
          return S(t);
        case "group":
          return w(t);
      }
    }, m = i(() => n.multiple ? T : A), f = i(() => n.multiple ? v : b);
    return (t, a) => (p(), y(d($), c({
      "reset-menu-on-options-change": e.resetMenuOnOptionsChange,
      "render-label": e.renderLabel ? e.renderLabel : e.type === "avatar" ? s : e.showTooltip ? d(B) : d(h),
      "render-tag": e.renderTag ? e.renderTag : e.type === "avatar" ? m.value : f.value,
      id: e.id
    }, t.$attrs, {
      placeholder: e.placeholder,
      options: e.options,
      disabled: e.disabled,
      value: e.value,
      class: "hl-select",
      filterable: e.filterable,
      show: e.show,
      multiple: e.multiple,
      loading: e.loading,
      clearable: e.clearable,
      remote: e.remote,
      tag: e.tag,
      size: e.size,
      "max-tag-count": e.maxTagCount,
      onScroll: a[0] || (a[0] = (l) => t.$emit("scroll", l)),
      onSearch: a[1] || (a[1] = (l) => t.$emit("search", l)),
      "onUpdate:value": a[2] || (a[2] = (l, g) => t.$emit("update:value", l, g)),
      "onUpdate:show": a[3] || (a[3] = (l) => t.$emit("update:show", l))
    }), {
      header: r(() => [
        o(t.$slots, "header")
      ]),
      action: r(() => [
        o(t.$slots, "action")
      ]),
      arrow: r(() => [
        o(t.$slots, "arrow")
      ]),
      empty: r(() => [
        o(t.$slots, "empty")
      ]),
      _: 3
    }, 16, ["reset-menu-on-options-change", "render-label", "render-tag", "id", "placeholder", "options", "disabled", "value", "filterable", "show", "multiple", "loading", "clearable", "remote", "tag", "size", "max-tag-count"]));
  }
}), I = C;
export {
  I as default
};
